import { render, staticRenderFns } from "./dpCommeIntroduce.vue?vue&type=template&id=05eb1bba&scoped=true"
import script from "./dpCommeIntroduce.vue?vue&type=script&lang=js"
export * from "./dpCommeIntroduce.vue?vue&type=script&lang=js"
import style0 from "./dpCommeIntroduce.vue?vue&type=style&index=0&id=05eb1bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb1bba",
  null
  
)

export default component.exports